export default {
      id: "purchases-menu-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#purchases-menu-usage",
      toString: function () {
        return this.url;
      }
    }